// Meetings feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.meetings.query`) intézi; a kulcsok itt élnek (cache-egységesítés). A
// `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika van (a tickets minta).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `q` a szabad-szöveg (cím), a `from`/`to` a kezdő-időpont tartománya UTC ISO-IDŐPONTKÉNT (a naptár a látható
 *  nézet budapesti napjaiból képzi, `fromZonedTime`-mal — nap-stringet NEM küld, a BFF instantot hasonlít),
 *  az `order` a fix `startsAt` rendezés iránya (a legacy naptár-lista alap: DESC), a `location` a helyszín-szűrő
 *  (vesszős lista, ahogy az URL-ben áll; üres = mind). */
export interface MeetingListFilters {
  q: string;
  location: string;
  from: string;
  to: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista-cache egységes címzése. */
export const meetingKeys = {
  all: ['meetings'] as const,
  lists: () => ['meetings', 'list'] as const,
  list: (filters: MeetingListFilters) => ['meetings', 'list', filters] as const,
};
